<template>
	<span class="status-dot">
		<span class="status-dot__dot" :class="'status-dot__dot--' + status"></span>
		<span class="status-dot__label">{{ _label }}</span>
	</span>
</template>

<script>
/**
 * Colored circle + label for a fraud alarm status. Matches the ● glyph
 * used in FraudAlarmWindow's header so the list and the detail feel
 * visually consistent.
 *
 *   open      — red  (unresolved)
 *   dismissed — gray (closed, no concern)
 *   escalated — amber (needs follow-up)
 */
const LABELS = {
	open:      'Åben',
	dismissed: 'Afvist',
	escalated: 'Eskaleret'
};

export default {
	props: {
		status: { type: String, required: true }
	},
	computed: {
		_label() { return LABELS[this.status] || this.status; }
	}
};
</script>

<style lang="scss" scoped>
.status-dot {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: inherit;

	&__dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		flex: 0 0 8px;

		&--open      { background: #f7223f; }
		&--dismissed { background: #888888; }
		&--escalated { background: #d6a000; }
	}

	&__label {
		line-height: 1.3;
	}
}
</style>
